export enum WeatherWidgetTemperatureTypes {
  Current,
  Min,
  Max,
}
